import { render, staticRenderFns } from "./PhoneMaskedField.vue?vue&type=template&id=8dda0c94"
import script from "./PhoneMaskedField.vue?vue&type=script&lang=js"
export * from "./PhoneMaskedField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports